/**
 * @author Ariel
 * @date 2021-12-29
 * @desc 短视频关注列表页配置
 */
import React from 'react'

let componentName = 'shortVideoPersonRelation'

const columns = [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '关注人姓名',
    name: 'fullName',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '关注人账号',
    name: 'userName',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '被关注人姓名',
    name: 'relatedFullName',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '被关注人账号',
    name: 'relatedUserName',
    searchItem: {},
    tableItem: {}
  },
  {
    title: '关注时间',
    name: 'relationTime',
    tableItem: {}
  },
  {
    title: '互相关注',
    name: 'type',
    tableItem: {},
    searchItem: {type: 'select'},
    dict: [
      {code: 2, codeName: '是'},
      {code: 1, codeName: '否'},
    ]
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['export'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: {icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          },
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort: [],
      rowOperateView: [],
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
}

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
